export default __webpack_public_path__ + "static/media/dinosor.1db352e5.png";